export default {
  apply_socialPitch:
    'Help us get a glimpse of who you are outside the confines of a resume or cover letter. ',
  apply_submit: 'Submit application',
  apply_submitting: 'Submitting..',
  apply_cv_label: 'CV/Resumé',
  apply_coverLetter_label: 'Cover Letter',
  apply_email_label: 'Email',
  apply_name_label: 'Full name',
  apply_sex_label: 'Sex',
  apply_ssn_label: 'Social Security Number',
  apply_phone_label: 'Phone',
  apply_successModal_title: 'Application received',
  apply_successModal_text:
    'A confirmation has been sent to your e-mail address. If you do not receive the confirmation message within a few minutes, please check your Spam folder.',
  apply_successModal_backToJobs: 'Back to jobsite',
  he: '',
  apply_error_required: 'This field is required',
  apply_error_email: 'Invalid email entered',
  apply_error_ssn: 'Invalid ssn entered',
  apply_connect: 'Connect with ',
  apply_connected: 'connected',

  backToJobs: 'Back to Jobs',
  backToDetail: 'Back to job description',
  openings_singular: '{0} Current openings',
  openings_plural: '{0} Current openings',
  no_openings: 'Currently no openings',
  apply_button: 'Apply now',
  deadline_display: 'Deadline',
  vacancies_singular: 'opening',
  vacancies_plural: 'openings',
  filter_search_placeholder: 'Search',
  accept_terms_body_text: 'Check here to indicate that you have read and agree to the terms of the',
  fifty_privacy_policy: ' 50skills Privacy Policy',
  privacy_policy_and: ' and',
  company_privacy_policy: '{0} Privacy Policy',
  terms_agreement_required: 'Agreement to the terms is required.',
  apply_form_has_errors: 'The form above contains errors.',
  job_list_no_openings_main: 'No opening at the moment',
  job_list_no_openings_sub: 'Please check back later!',
  job_list_no_language_data: 'This job does not currently have an English translation',
  job_list_no_language_data_sub:
    'Too see the job in other languages, switch languages in the top right hand corner.',
  jobStatus_full_time: 'Full time',
  jobStatus_part_time: 'Part time',
  jobStatus_per_diem: 'Per diem',
  jobStatus_not_specified: 'Not specified',
  en: 'English',
  is: 'Íslenska',
  pl: 'Polski',
  no: 'Norsk',
  sv: 'Svenska',
  fr: 'Français',
  languageSwitcher_title: 'Select language',
  'The submitted file is empty.': 'The submitted file is empty.',
  job_does_not_exist_header: "The page you are looking for doesn't exist",
  job_does_not_exist_sub_header: 'You may have mistyped the address or the job has been removed',
  job_does_not_exist_link: 'Take me to the homepage',
  fiftyFooter_poweredBy: 'Powered by',
  jobStatus_title: 'Job status',
  cookie_consent_main_text: 'By using the site, you agree to our',
  cookie_consent_privacy_cta_text: ' cookie policy.',
  cookie_consent_privacy_button_text: 'Dismiss',
  department_title_unknown: 'Not specified {0}',
  helpers_add: 'Add file',
};
